import { Typography } from 'antd';

const { Title } = Typography;

const Quote = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '2rem', gap: '1rem' }}>
      <img src="./phoenix.png" alt="phoenix" style={{ maxWidth: '200px' }} />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '2rem' }}>
        <Title level={5}>“Life tried to crush it, but only succeeded in creating a diamond.”</Title>
        <Title level={4}>Welcome to ERP</Title>
      </div>
    </div>
  );
};

export default Quote;
